<template>
    <div class="kingfisher_container">
        <div class="kingfisher_header">
            <kf-header></kf-header>
        </div>
        <div class="kingfisher_content">
            <kf-main-content v-show="showContent===0"></kf-main-content>
            <kf-content-list v-show="showContent===1"></kf-content-list>
            <kf-content-detail v-show="showContent===2"></kf-content-detail>
        </div>
    </div>
</template>

<script>
    import kfHeader from './header/Header'
    import kfMainContent from './content/main'
    import kfContentList from './content/contentList'
    import kfContentDetail from './content/contentDeatil'
    import {onMounted} from 'vue'
    import {useRouter} from 'vue-router'
    import {setToken} from "@/utils/auth";
    import keyModel from "@/model/keys";
    import envModel from "@/model/env";
    import menuModel from '@/model/menu'

    export default {
        name: "kf-main",
        components: {
            kfHeader, kfMainContent, kfContentList, kfContentDetail
        },
        setup() {
            envModel.env.value = "designer";
            const router = useRouter();

            if (router.currentRoute != undefined && router.currentRoute.value.params != undefined && router.currentRoute.value.params.token != undefined) {
                setToken(router.currentRoute.value.params.token)
            }

            keyModel.init();

            onMounted(() => {
            });

            const handleClick = function () {
            };



            return {
                handleClick,
                showContent: menuModel.showContent,
                showDetail: menuModel.showDetail
            }
        }
    }
</script>

